import { Injectable } from '@angular/core';
import { FirebaseData } from '../providers/firebase-data';
import { Observable } from 'rxjs/Observable';
import { Utils } from '../providers/utils';
import firebase from 'firebase';

@Injectable()
export class CartData {
    public realtimeDb: any;

    constructor(
        private firebaseData: FirebaseData
        ) {
    	this.realtimeDb = firebase.database();
    }

    public getAllItems(uid){
        var self = this;
        return Observable.create((observer) =>{
            self.realtimeDb.ref('user-cart/' + uid).on('value', data => {
                let items = [];
                if(data){
                    items = Utils.toArray(data.val()).reverse();
                }
                observer.next(items);
            });
        });
    }

    public addItem(uid, product){
    	return Observable.create((observer) =>{
            // Get a key for a new Post.
            var newItemKey = firebase.database().ref().child('user-cart').push().key;
            var updates = {};
            
            // Get timestamp
            var timeStamp = (<any>firebase.database).ServerValue.TIMESTAMP;
            product.timestampCreated = timeStamp

            
            // Just upload cart item
            updates['/user-cart/' + uid + '/' + newItemKey] = product;
        
            this.realtimeDb.ref().update(updates).then(function(){
                observer.next(newItemKey);
            }, function(error){
                observer.next(false);
            });
            
    	});
    }

    public updateItem(uid, product){
        return Observable.create((observer) =>{
            var updates = {};
            // Just upload cart item
            updates['/user-cart/' + uid + '/' + product.value.cartItemId] = product;
        
            this.realtimeDb.ref().update(updates).then(function(){
                observer.next(true);
            }, function(error){
                observer.next(false);
            });
        });
    }
   
    public deleteItem(uid, itemId){
    	return Observable.create((observer) => {
    		var updates = {};
            updates['/user-cart/' + uid + '/' + itemId]     = null;

            this.realtimeDb.ref().update(updates).then(function(){
                observer.next(true);
            }, function(error){
                observer.next(false);
            });
    	})
    }    
}


// WEBPACK FOOTER //
// ./src/providers/cart-data.ts